module.exports = __webpack_public_path__ + "img/ukraine-02.c0e780f1.svg";